// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"9275025b","272":"2fadbeea","313":"14d8e46b","405":"bf284e6a","886":"64cbd1e7"}[chunkId] + ".chunk.js";
};